var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"address-blockie"},[_c('img',{staticClass:"address-blockie-image",attrs:{"src":_vm.dataUrl,"alt":"address"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }